import SearchChips from 'components/SearchInputs/SearchChips/SearchChips';
import SectionHeader from 'components/Basic/SectionHeader/SectionHeader';
import SelectBatters from 'components/SearchInputs/SelectBatters';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import usePracticeBatterSessionReport from 'hooks/PracticeReport/Batter/usePracticeBatterSessionReport';
import SelectPracticeSessionType from 'components/SearchInputs/SelectPracticeSessionType';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const PracticeBatterSessionSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = usePracticeBatterSessionReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectPracticeSessionType
            playerType='Batter'
            selectedPracticeSessionTypeId={searchCriteria.sessionType?.id}
            onChange={(sessionType) =>
              setSearchCriteria({
                sessionType,
                dateRanges: undefined,
                seasonNames: undefined,
                players: undefined,
              })
            }
          />
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                players: undefined,
              })
            }
          />
          <SelectBatters
            selectedBatters={searchCriteria.players}
            onChange={(players) => setSearchCriteria({ players })}
            dateRanges={searchCriteria.dateRanges}
            levelId={undefined}
            teamId={undefined}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={undefined}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default PracticeBatterSessionSearchCriteria;
